import { useAppSelector } from '@casops/store/hooks';

export const useFormEditMode = (editModeOverride?: boolean) => {
  const sidePanelEditMode = useAppSelector(state => state.global.sidePanelEditMode);
  return editModeOverride ?? sidePanelEditMode;
};
